import { render, staticRenderFns } from "./averageTimeChart.vue?vue&type=template&id=b7ff6e72&"
import script from "./averageTimeChart.vue?vue&type=script&lang=js&"
export * from "./averageTimeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports